import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { style: {"color":"red","font-size":"12px","margin-left":"5px"} }
const _hoisted_2 = { style: {"color":"red","font-size":"12px","margin-left":"5px"} }
const _hoisted_3 = { class: "dialog-footer" }

import {
  computed,
  ref,
  PropType,
  Ref,
  watch,
  nextTick,
  reactive,
} from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { upsertBrand } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import useFormRules from '@/hooks/useFormRules'
import FormRulesFactory from '@/common/formRules'
import SelectOperator from '@/components/SelectOperator.vue'
import InfoTooltip from '@/components/InfoTooltip.vue'

export type OperationType = 'create' | 'edit'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'BrandUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  operationType: {
    type: String as PropType<OperationType>,
    required: true,
  },
  info: {
    type: Object as PropType<Record<string, any>>,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { country, currency } = useProtocolEnums()
const { t } = useI18n()





const createRawFormData = () => ({})

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())

const operatorFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['country', 'currency', 'operatorID'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(
    ['operatorPrincipal', 'name', 'domain', 'defKey'],
    'inputEmpty',
    'inputInvalid',
  ),
  ...FormRulesFactory.generateCustomRules(['principalPhone'], 'inputEmpty', 'inputInvalid', {
    pattern: /^[+]?(\d{1,4}[-()])?\(?\d{1,4}\)?[-]?\d{1,4}[-]?\d{1,4}[-]?\d{1,4}$/,
    min: 4,
    max: 15,
  }),
  ...FormRulesFactory.generateCustomRules(['principalEmail'], 'inputEmpty', 'inputInvalid', {
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  }),
})

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const dialogTitle = computed(
  () =>
    ({
      create: `${t('Base.add')}`,
      edit: `${t('Base.edit')}`,
    }[props.operationType]),
)

watch(showDialog, async (val) => {
  if (val) {
    if (props.operationType !== 'create') {
      formData.value = {
        id: props.info?.id,
        name: props.info?.name,
        currency: props.info?.currency,
        desc: props.info?.desc,
        operatorID: props.info?.operatorID,
        domain: props.info?.domain,
        defKey: props.info?.defKey,
        aliAppKey: props.info?.aliAppKey,
        wxAppKey: props.info?.wxAppKey,
        opQrcodeFix: props.info?.opQrcodeFix,
        homeQrcodeFix: props.info?.homeQrcodeFix,
      }
    } else {
      await nextTick()
      formCom.value.clearValidate()
    }
  } else {
    formData.value = createRawFormData()
  }
})

const submit = async () => {
  try {
    await formCom.value.validate()
    isSubmitting.value = true
    await upsertBrand({ brand: formData.value })
    if (props.operationType === 'edit') {
      ElMessage.success(t(`Base.updateSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "50%",
    class: "upsert-dialog",
    title: _unref(dialogTitle),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: operatorFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.name'),
                    prop: "name",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                        minlength: 3
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorID",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: formData.value.operatorID,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.operatorID) = $event)),
                        disabled: props.operationType == 'edit' ? true : false
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.currency'),
                    prop: "currency",
                    required: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('Operation.currency')), 1),
                      _createElementVNode("span", _hoisted_1, "(" + _toDisplayString(_unref(t)('Operation.currencyNotChange')) + ")", 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.currency,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.currency) = $event)),
                        disabled: props.operationType == 'edit' ? true : false,
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currency), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.desc'),
                    prop: "desc"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.desc,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.desc) = $event)),
                        rows: 1,
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider, { "content-position": "left" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, "(" + _toDisplayString(_unref(t)('Operation.importNotChange')) + ")", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.opQrcodeFix'),
                    prop: "opQrcodeFix",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.opQrcodeFix,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.opQrcodeFix) = $event)),
                        placeholder: "https://xxx.xxx.com/qr?biz=lcharge&sn="
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.homeQrcodeFix'),
                    prop: "homeQrcodeFix"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.homeQrcodeFix,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.homeQrcodeFix) = $event)),
                        placeholder: "https://xxx.xxx.com/home/evse"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.defKey'),
                    prop: "defKey",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.defKey,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.defKey) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.aliAppId'),
                    prop: "aliAppKey"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.aliAppKey,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.aliAppKey) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.wxAppId'),
                    prop: "wxAppKey"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.wxAppKey,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.wxAppKey) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})